import { render } from "./AnswerPage.vue?vue&type=template&id=fa727bfc&scoped=true"
import script from "./AnswerPage.vue?vue&type=script&lang=js"
export * from "./AnswerPage.vue?vue&type=script&lang=js"

import "./AnswerPage.vue?vue&type=style&index=0&id=fa727bfc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa727bfc"]])

export default __exports__